// Client-Entry: registriert die BeastSearch-Komponenten als async components
// in der globalen Ceres-Vue-Instanz. Kein eigenes Mounting – Ceres kompiliert
// die Tags aus dem Twig-Markup bzw. hydratisiert das SSR-Ergebnis.
import './app/publicPath'
import { registerResultClickTracking } from './resultClickTracking'

function registerComponents (Vue) {
  Vue.component('BeastSearchBox', function () { return import('./app/BeastSearchBox.vue') })
  Vue.component('BeastSearchFilter', function () { return import('./app/BeastSearchFilter.vue') })
  Vue.component('BeastSearchInfo', function () { return import('./app/BeastSearchInfo.vue') })
  Vue.component('BeastSearchActiveFilters', function () { return import('./app/BeastSearchActiveFilters.vue') })
}

// window.Vue kommt aus dem Theme-Bundle (ceres-base/ceres-client). Falls dieses
// Bundle hier ausnahmsweise früher ausgeführt wird, nachziehen sobald das DOM
// steht – das ist immer noch vor dem Vue-Mount von Ceres.
if (window.Vue) {
  registerComponents(window.Vue)
} else {
  document.addEventListener('DOMContentLoaded', function () {
    if (window.Vue) {
      registerComponents(window.Vue)
    } else {
      console.error('BeastSearch: window.Vue nicht gefunden – Komponenten nicht registriert.')
    }
  })
}

// Klicks in der (von Ceres gerenderten) Trefferliste - siehe resultClickTracking.js
registerResultClickTracking()
